// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__FmnUG","footer__content":"Footer_footer__content__O2DWY","footer__text":"Footer_footer__text__MMllK","site_url":"Footer_site_url__zOmqq"};